define('post-form',['controller', 'post-editor', 'lib/select2.min', 'lib/select2_locale_de_informal' /*, 'lib/jquery-ui'*/], 
function(controller, editor) {
	function init() {
		$('.select').attr('multiple');
		$('.select').select2({
			maximumSelectionSize: 7,
			width: '100%',
			placeholder: 'Wähle bis zu sieben Tags ▾',
			language: 'de_informal'
		});

		editor.init();
	}

	controller.on(['posts/add', 'posts/edit', 'suggested_edits/add'], function() {
		init();
	}, function() {
		editor.destroy();
	});
});

